import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d98490ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "value"]
const _hoisted_3 = ["id", "value"]
const _hoisted_4 = {
  key: 2,
  class: "text-red-600 text-xs"
}

import { withDefaults } from "vue";
import type { InputHTMLAttributes } from "vue";
import { maska as vMaska } from "maska";
import { useField } from "vee-validate";
import { Money3Directive } from "v-money3";
import money from "@/config/money";

interface IProps extends InputHTMLAttributes {
	name: string;
	type?: string;
	label?: string;
	maska?: string | string[];
	placeholder?: string;
	disabled?: boolean;
	value?: any;
	modelValue?: any;
	isMoney: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Input',
  props: {
    name: null,
    type: { default: "text" },
    label: null,
    maska: { default: undefined },
    placeholder: null,
    disabled: { type: Boolean },
    value: null,
    modelValue: null,
    isMoney: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props as { name: string, type: string, label?: string, maska: string | string[], placeholder?: string, disabled?: boolean, value?: any, modelValue?: any, isMoney: boolean }



const vMoney3 = Money3Directive;
const initialValue = props.value ? props.value : props.modelValue;

const {
	value: inputValue,
	errorMessage,
	handleBlur,
	handleChange,
	meta,
} = useField(props.name, undefined, {
	initialValue,
});



const onInput = (event: any) => {
	handleChange(event, true);
	emit("update:modelValue", event.target.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", {
      for: props.name
    }, _toDisplayString(__props.label), 9, _hoisted_1),
    (!__props.isMoney)
      ? _withDirectives((_openBlock(), _createElementBlock("input", _mergeProps({ key: 0 }, props, {
          id: props.name,
          class: ["input", { 'has-error': !!_unref(errorMessage) }],
          value: _unref(inputValue),
          onInput: onInput,
          onBlur: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleBlur) && _unref(handleBlur)(...args)))
        }), null, 16, _hoisted_2)), [
          [_unref(vMaska), props.maska]
        ])
      : _withDirectives((_openBlock(), _createElementBlock("input", _mergeProps({ key: 1 }, props, {
          id: props.name,
          class: ["input", { 'has-error': !!_unref(errorMessage) }],
          value: _unref(inputValue),
          onInput: onInput,
          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleBlur) && _unref(handleBlur)(...args)))
        }), null, 16, _hoisted_3)), [
          [_unref(vMoney3), _unref(money)]
        ]),
    (_unref(errorMessage) && _unref(meta).touched)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})